/**
 * Query keys for the custom tables admin grid.
 *
 * The empty check was previously keyed "custom-tables-admin-empty-check", a
 * different string from the grid's own key, so refreshing both took two
 * invalidations. As a segment under the same root, one reaches both.
 */
export const customTablesAdminKeys = {
  all: ["custom-tables-admin"],
  lists: () => [...customTablesAdminKeys.all, "list"],
  list: () => [...customTablesAdminKeys.lists()],
  emptyCheck: () => [...customTablesAdminKeys.all, "empty-check"],
};
